<template>
  <div class="job-title-rank is-flex is-align-items-center is-flex-wrap-wrap" dir="rtl">
    <span class="tag is-light ml-2 job-title-rank-number" :class="{ 'is-info': rank !== null }">
      {{ rank === null ? '—' : rank }}
    </span>
    <button
      type="button"
      class="button is-small is-white px-2 job-title-rank-up"
      aria-label="העברה למעלה"
      :disabled="!canUp"
      @click="$emit('up')"
    >▲</button>
    <button
      type="button"
      class="button is-small is-white px-2 job-title-rank-down"
      aria-label="העברה למטה"
      :disabled="rank === null"
      @click="$emit('down')"
    >▼</button>
    <label v-if="rank !== null" class="radio mr-2 is-size-7 job-title-rank-primary">
      <input type="radio" :name="radioName" :checked="isPrimary" @click="$emit('primary')" />
      {{ texts.primary }}
    </label>
    <span v-if="editorText" class="tag is-white is-size-7 mr-2 job-title-editor">{{ editorText }}</span>
  </div>
</template>

<script>
import { TEXTS } from '@/custom/classes/applicant_job_titles.js'

export default {
  name: 'JobTitleRankCell',
  props: {
    rank: { type: Number, default: null },
    canUp: { type: Boolean, default: true },
    isPrimary: { type: Boolean, default: false },
    editorText: { type: String, default: '' },
    radioName: { type: String, default: 'job-title-primary' }
  },
  data () {
    return { texts: TEXTS }
  }
}
</script>
